/* STOPI shop pages: product gallery, variants, sticky bar, collection sort */
(function () {
  if (window.__stopiShop) { return; }
  window.__stopiShop = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  function once(el, key, fn) { var k = '__stopishop_' + key; if (el[k]) { return; } el[k] = true; fn(el); }

  function initProduct(root) {
    var form = $('#stopi-product-form', root);
    var slides = $$('.pp-slide', root), thumbs = $$('[data-go]', root);
    function go(i) {
      slides.forEach(function (s, k) {
        var on = k === i; s.classList.toggle('on', on);
        var v = $('video', s);
        if (v) { if (on) { if (!v.getAttribute('src') && v.dataset.src) { v.src = v.dataset.src; } v.muted = true; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } else { v.pause(); } }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.go); }); });

    var dataEl = $('[data-variants]', root), variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var labels = $('[data-labels]', root) ? JSON.parse($('[data-labels]', root).textContent) : { atc: 'Добави', soldout: 'Изчерпано' };
    var idInput = $('[data-variant-id]', root);
    function chosen() {
      return $$('.pp-opt', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
    }
    var tierEls = $$('[data-tiers] input[name="tier"]', root), splitEl = $('[data-split]', root), addonEl = $('[data-addon]', root), ownQty = null;
    function curTier() { return tierEls.filter(function (t) { return t.checked; })[0]; }
    function buildSplit() {
      if (!splitEl) { return; }
      var c = curTier(), q = c ? +c.value : 1, pills = $('[data-split-pills]', splitEl);
      if (q < 2) { splitEl.hidden = true; ownQty = null; return; }
      if (ownQty === null || ownQty > q) { ownQty = q; }
      splitEl.hidden = false; pills.innerHTML = '';
      for (var own = q; own >= 0; own--) {
        (function (o) {
          var b = document.createElement('button'); b.type = 'button';
          var parts = []; if (o > 0) { parts.push(o + ' × ' + splitEl.dataset.own); } if (q - o > 0) { parts.push((q - o) + ' × ' + splitEl.dataset.partner); }
          b.textContent = parts.join(' + '); b.setAttribute('aria-pressed', o === ownQty);
          b.addEventListener('click', function () { ownQty = o; buildSplit(); updateDyn(); }); pills.appendChild(b);
        })(own);
      }
    }
    function mixed() { var c = curTier(); return !!(splitEl && !splitEl.hidden && c && ownQty !== null && ownQty < +c.value); }
    function updateDyn() { var d = $('.pp-dyn', root); if (d) { d.style.display = (mixed() || (addonEl && addonEl.checked)) ? 'none' : ''; } }
    function applyTier() {
      var c = curTier();
      if (!c) { return; }
      var q = $('[data-qty]', root); if (q) { q.value = c.value; }
      var cmp = $('[data-compare]', root), ad = !!(addonEl && addonEl.checked);
      var total = ad ? c.dataset.totalAd : c.dataset.total, full = ad ? c.dataset.fullAd : c.dataset.full;
      $$('[data-price]', root).forEach(function (e) { e.textContent = total; });
      if (cmp) { cmp.innerHTML = (ad || +c.dataset.save > 0) ? '<s>' + full + '</s>' : ''; }
      buildSplit(); updateDyn();
    }
    tierEls.forEach(function (t) { t.addEventListener('change', function () { ownQty = null; applyTier(); }); });
    if (addonEl) { addonEl.addEventListener('change', applyTier); }
    if (tierEls.length) { applyTier(); }
    if (form && (splitEl || addonEl)) {
      form.addEventListener('submit', function (e) {
        var ad = !!(addonEl && addonEl.checked);
        if (!mixed() && !ad) { return; }
        e.preventDefault();
        var c = curTier(), q = c ? +c.value : 1, items = [], ownId = (idInput && idInput.value) || (splitEl && splitEl.dataset.ownId);
        var own = mixed() ? ownQty : q;
        if (own > 0) { items.push({ id: +ownId, quantity: own }); }
        if (mixed() && q - own > 0) { items.push({ id: +splitEl.dataset.partnerId, quantity: q - own }); }
        if (ad) { items.push({ id: +addonEl.dataset.addonId, quantity: 1 }); }
        var btns = $$('[data-atc],[data-atc2]', root); btns.forEach(function (b) { b.disabled = true; });
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
          .then(function () { location.href = '/cart'; })
          .catch(function () { btns.forEach(function (b) { b.disabled = false; }); form.submit(); });
      });
    }
    var kitEl = $('[data-kit]', root), kitTog = $('[data-kit-toggle]', root), kitCol = $('[data-kit-colors]', root), kitId = null, kitBase = null, kitBaseCmp = '';
    function fmtM(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
    function applyKit() {
      if (!kitEl) { return; }
      var on = kitTog.checked, qEl = $('[data-qty]', root), q = Math.max(1, +(qEl && qEl.value) || 1);
      var unit = +kitEl.dataset.unitC, kit = +kitEl.dataset.kitC, towel = +kitEl.dataset.towelC, cmp = $('[data-compare]', root);
      if (kitBase === null) { var p0 = $('.pp-total [data-price]', root); kitBase = p0 ? p0.textContent : fmtM(unit); kitBaseCmp = cmp ? cmp.innerHTML : ''; }
      kitCol.hidden = !on;
      if (on) {
        if (!kitId) { kitId = $('[data-kit-id]', kitCol).dataset.kitId; }
        $$('[data-price]', root).forEach(function (e) { e.textContent = fmtM(kit + (q - 1) * unit); });
        if (cmp) { cmp.innerHTML = '<s>' + fmtM(q * unit + towel) + '</s>'; }
      } else {
        $$('[data-price]', root).forEach(function (e) { e.textContent = kitBase; });
        if (cmp) { cmp.innerHTML = kitBaseCmp; }
      }
      var d = $('.pp-dyn', root); if (d) { d.style.display = on ? 'none' : ''; }
    }
    if (kitEl) {
      kitTog.addEventListener('change', applyKit);
      $$('[data-kit-id]', kitCol).forEach(function (b) { b.addEventListener('click', function () { kitId = b.dataset.kitId; $$('[data-kit-id]', kitCol).forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); }); });
      $$('[data-q]', root).forEach(function (b) { b.addEventListener('click', function () { setTimeout(applyKit, 0); }); });
      var qIn = $('[data-qty]', root); if (qIn) { qIn.addEventListener('input', applyKit); qIn.addEventListener('change', applyKit); }
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!kitTog.checked) { return; }
          e.preventDefault();
          var q = Math.max(1, +($('[data-qty]', root).value) || 1), items = [{ id: +(kitId || $('[data-kit-id]', kitCol).dataset.kitId), quantity: 1 }];
          if (q > 1) { items.push({ id: +idInput.value, quantity: q - 1 }); }
          var btns = $$('[data-atc],[data-atc2]', root); btns.forEach(function (b) { b.disabled = true; });
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
            .then(function (r) { if (!r.ok) { throw new Error('add'); } return r.json(); })
            .then(function () { location.href = '/cart'; })
            .catch(function () { btns.forEach(function (b) { b.disabled = false; }); form.submit(); });
        });
      }
    }
    var panels = $$('[data-tint-panel]', root);
    function sync(v) {
      if (v && v.media) { slides.forEach(function (s, k) { if (s.dataset.mediaId == v.media) { go(k); } }); }
      if (!panels.length || !v) { return; }
      var opts = v.options.map(function (o) { return String(o).toLowerCase(); });
      panels.forEach(function (p) {
        var ok = opts.indexOf(p.dataset.percent.toLowerCase()) > -1 && opts.some(function (o) { return o.split(' ').indexOf(p.dataset.series) > -1; });
        var was = p.hidden; p.hidden = !ok;
        if (ok && was) { $$('.pt-bar', p).forEach(function (b) { var w = b.style.getPropertyValue('--w'); b.style.setProperty('--w', '0%'); requestAnimationFrame(function () { requestAnimationFrame(function () { b.style.setProperty('--w', w); }); }); }); }
      });
    }
    function fit(sel, ch) {
      var best = null, bs = -1;
      variants.forEach(function (x) {
        if (x.options[ch] !== sel[ch]) { return; }
        var sc = 0; sel.forEach(function (o, i) { if (o !== null && x.options[i] === o) { sc++; } });
        if (sc > bs) { bs = sc; best = x; }
      });
      return best;
    }
    function refine(v) {
      $$('.pp-opt', root).forEach(function (f, i) {
        $$('label.pill-opt', f).forEach(function (l) {
          var inp = $('input', l), val = inp.value, c = null;
          variants.forEach(function (x) {
            if (x.options[i] !== val) { return; }
            for (var k = 0; k < i; k++) { if (x.options[k] !== v.options[k]) { return; } }
            if (!c || (function () { for (var k = i + 1; k < v.options.length; k++) { if (x.options[k] !== v.options[k]) { return false; } } return true; })()) { c = x; }
          });
          l.hidden = (i > 0 && !c);
          var sm = $('[data-pp-small]', l); if (sm && c) { sm.textContent = c.price_fmt.replace(/[.,]00(?!\d)/, ''); }
        });
      });
    }
    function update(ch) {
      var sel = chosen();
      var v = variants.filter(function (x) { return sel.every(function (o, i) { return o === null || x.options[i] === o; }); })[0];
      if (!v && typeof ch === 'number') {
        v = fit(sel, ch);
        if (v) { $$('.pp-opt', root).forEach(function (f, i) { $$('input', f).forEach(function (r) { r.checked = r.value === v.options[i]; }); }); }
      }
      if (!v) { return; }
      refine(v);
      if (idInput) { idInput.value = v.id; }
      sync(v);
      if (tierEls.length) { setTimeout(applyTier, 0); }
      $$('[data-price]', root).forEach(function (e) { e.textContent = v.price_fmt; });
      var cmp = $('[data-compare]', root); if (cmp) { cmp.innerHTML = v.compare_fmt ? '<s>' + v.compare_fmt + '</s>' : ''; }
      ['[data-atc]', '[data-atc2]'].forEach(function (s) {
        $$(s, root).forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? labels.atc : labels.soldout; });
      });
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }
    $$('.pp-opt input', root).forEach(function (i) { i.addEventListener('change', function () { update(+i.closest('.pp-opt').dataset.opt); }); });
    (function () { var sel0 = chosen(), v0 = variants.filter(function (x) { return sel0.every(function (o, i) { return o === null || x.options[i] === o; }); })[0]; if (v0) { refine(v0); sync(v0); } })();

    var qty = $('[data-qty]', root);
    $$('[data-q]', root).forEach(function (b) {
      b.addEventListener('click', function () { var n = Math.max(1, (+qty.value || 1) + (+b.dataset.q)); qty.value = n; });
    });

    var sticky = $('[data-sticky]', root), atc = $('[data-atc]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { var past = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('show', past); sticky.setAttribute('aria-hidden', !past); });
      }, { threshold: 0 }).observe(atc);
    }
    go(0);
  }

  function init() {
    $$('[data-product]').forEach(function (el) { once(el, 'product', initProduct); });
    $$('[data-sort]').forEach(function (s) {
      once(s, 'sort', function () {
        s.addEventListener('change', function () {
          var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
        });
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
